module.exports = __webpack_public_path__ + "img/Airbnb-Hybrid-Staying-Focused2-scaled.6194baf3.jpg";